import "./Tabs.scss";

import React from "react";
import clsx from "clsx";
import { Tabs as ReactTabs } from "react-tabs";

const Tabs = ({
    className = '',
    children,
    ...otherProps
}) => {
    return <ReactTabs className={clsx('tabs-container', className)} {...otherProps}>
        {children}
    </ReactTabs>
};

export default Tabs;